import { Component, OnInit } from '@angular/core';
import { CommunicationService } from '../../../../core/services/communication.service';
import { fuseAnimations } from '../../../../core/animations';
import { MatTableDataSource } from '@angular/material/table';
import {FuseConfigService} from '../../../../core/services/config.service';
import { EventService } from '../../../../core/services/event.service';

@Component({
    selector: 'whatsapp-page',
    templateUrl: './whatsapp.component.html',
    styleUrls: ['./whatsapp.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class WhatsappComponent implements OnInit {
  dataSource;
  displayedColumns: string[] = ['organization', 'image', 'user', 'count'];
  pageSize = 10;
  pageIndex = 0;
  totalCount;
  sortBy = 'organization';
  sortDirection = 'asc';

  constructor(private communicationService: CommunicationService, private fuseConfig: FuseConfigService,
              public eventService: EventService) {
  }

  ngOnInit() {
    this.getWhatsApp();
  }

  getImage(name) {
    return this.eventService.getFileStream(name);
  }

  getWhatsApp() {
    this.communicationService.getWhatsAppHistory(this.pageIndex + 1, this.pageSize, this.sortBy, this.sortDirection)
      .subscribe((res: any) => {
        this.totalCount = res.totalCount;
        this.dataSource = new MatTableDataSource<any>(res.list);
    });
  }

  changePageEmitter(e) {
    this.pageIndex = e.pageIndex;
    this.pageSize = e.pageSize;
    this.getWhatsApp();
  }

  sortData(e) {
    this.sortBy = e.active;
    this.sortDirection = e.direction;
    this.getWhatsApp();
  }
}
